import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  onConfirm: () => void
}

const FinishAutoBreakModal = ({ onClose, onConfirm }: Props) => {
  return (
    <Modal
      illustration="alert"
      title={i18n.t('clock_in.finish_auto_break_alert.title')}
      description={i18n.t('clock_in.finish_auto_break_alert.description')}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('clock_in.finish_auto_break_alert.resume_break')}
          </Button>
          <Button onClick={onConfirm}>
            {i18n.t('clock_in.finish_auto_break_alert.go_back_to_work')}
          </Button>
        </>
      }
    />
  )
}

export default observer(FinishAutoBreakModal)
